import React from 'react'
import { mutualTheme } from '~/utils/theme'
import { Box, Typography, useMediaQuery } from '@material-ui/core'

export interface PendencyCardRowProps {
  title: string
}

export const PendencyCardRow: React.FC<PendencyCardRowProps> = (props) => {
  const { title, children } = props
  const matches = useMediaQuery(mutualTheme.breakpoints.down('lg'))

  return (
    <Box sx={{
      flex: 1,
      marginBottom: 3,
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Typography
        variant='airbnbH4'
        sx={{
          color: 'textGray2.main',
          marginBottom: 2
        }}>
        {title}
      </Typography>
      <Box sx={{
        display: 'flex',
        flexDirection: matches ? 'column' : 'row',
        alignItems: 'center',
        gap: 2
      }}>
        {children}
      </Box>
    </Box>
  )
}
